import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ITeam } from "../../team/team.type";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: 'team-chip-list',
    templateUrl: './team-chip-list.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule
    ]
})
export class TeamChipListComponent {

    protected showAllTeams = false;

    @Input() teams: string[];

    constructor(){}
}